import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=8353354c&"
import script from "./SendMessage.vue?vue&type=script&lang=ts&"
export * from "./SendMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports